import React from "react";
import { setInfoKey } from '../../api/information-collection/actions'

class KomfortDynamicGuaranteedCapitalForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.onChangeSelectValue = this.onChangeSelectValue.bind(this)
    }

    onChangeSelectValue(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }

    render() {
        const { customerId, disabled, initialValues, keyPrefix, personType } = this.props

        return (
            <>
                { initialValues[`${keyPrefix}Portfolio`].toLowerCase() === 'komfortdynamik' && 
                    <div className={`form-row align-items-center`}>

                        <div className="col-6">
                            <label className="col-12 col-xl d-xl-inline col-form-label pl-0">Tryggður höfuðstóll: </label>
                        </div>
                        <div className="col-6 text-right">
                            <select className="custom-select col-12 col-sm-6" id={`leb-kd-percentage-${customerId}`} name={`${keyPrefix}KDpercentage`} onChange={this.onChangeSelectValue} value={initialValues[`${keyPrefix}KDpercentage`]} disabled={disabled || personType === "child"} >
                                <option value="80" disabled={disabled}>80%</option>
                                { personType !== "child" && <option value="60" disabled={disabled}>60%</option> }
                            </select>
                        </div>
                    </div>
                }
            </>
        )
    }
}

KomfortDynamicGuaranteedCapitalForm.defaultProps = {
    disabled: false,
    personType: "adult",
}

export default KomfortDynamicGuaranteedCapitalForm;
